const HOST_WRITER_ROUTE: string = `${process.env.REACT_APP_WRITER_API_ROUTE}`;

const ACCOUNT_API_ROUTE = `${HOST_WRITER_ROUTE}/account`;
export const LOGIN_API_ROUTE = `${ACCOUNT_API_ROUTE}/login`;
